<style scoped>
.in-page-advertisement-wrapper,
.banner-advertisement-wrapper {
    width: 100%;
}

.banner-advertisement-wrapper {
    max-width: 1200px;
}
</style>

<template>
    <div
        v-if="randomAdvrt"
        :style="{
            background: backgroundColorCode || ''
        }"
        class="flex justify-center"
        :class="{
            'cursor-pointer': randomAdvrt.advrtActTypeCode !== 'NONE'
        }"
        @click="clickAdvrt(randomAdvrt)"
    >
        <intersectionContainer
            mode="single"
            :targetIntersectionRatio="0.9"
            @changeToVisible="advertisementVisibleToUser(randomAdvrt)"
            :class="{
                'in-page-advertisement-wrapper': type === 'inPage',
                'banner-advertisement-wrapper': type === 'banner'
            }"
        >
            <ImageLoader
                :src="advrtImgUrl(randomAdvrt)"
                :srcError="tinyBlankGifImg"
                :ratio="ratio"
                :fillImgHeight="fillImgHeight"
                class="fill-full-width"
            />
        </intersectionContainer>
    </div>
</template>

<script>
import ImageLoader from './imageLoader.vue';
import shuffle from 'lodash/shuffle';
import ctx from '@/utils/ctx';
import advrtEventHandler from '../utils/advertisementEventHandler';
import intersectionContainer from '../components/intersectionContainer.vue';
import { marketingEventHandler } from '../utils/marketingDataProcessor';

const TYPE = {
    BANNER: 'banner',
    IN_PAGE: 'inPage'
};

export default {
    components: {
        ImageLoader,
        intersectionContainer
    },
    props: {
        type: { type: String, default: TYPE.BANNER },
        fillImgHeight: { type: Boolean, default: false }
    },
    data() {
        return {
            tinyBlankGifImg:
                'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
            randomSeed: 0
        };
    },
    computed: {
        advertisementList() {
            let advrtList =
                this.type === TYPE.BANNER
                    ? this.$store.getters.bannerAdvertisementList
                    : this.$store.getters.inPageAdvertisementList || [];

            const saleCatgSlctCode = this.$route.params.saleCatgSlctCode;
            if (this.type === TYPE.IN_PAGE && saleCatgSlctCode) {
                advrtList = advrtList.filter(
                    ad =>
                        ad.allSaleCatgAdvrtInd === 'Y' ||
                        ad.advrtSaleCatgSlctCode === saleCatgSlctCode
                );
            }
            return advrtList;
        },
        randomAdvrt() {
            this.randomSeed;
            return shuffle(this.advertisementList)[0];
        },
        backgroundColorCode() {
            return this.type === TYPE.BANNER
                ? this.randomAdvrt?.advrtImgBkgndColorCode
                : '';
        },
        ratio() {
            return this.type === TYPE.BANNER ? 1200 / 90 : 936 / 120;
        },
        advrtImgUrl() {
            return advrt => ctx('/advrtImageFile/' + advrt.advrtImgId);
        }
    },
    methods: {
        clickAdvrt(advrt) {
            if (
                advrt &&
                ((advrt.advrtProdKey && advrt.shopListKey) || advrt.trckSlctKey)
            ) {
                marketingEventHandler.advertisementClick(
                    advrt.advrtProdKey,
                    advrt.shopListKey,
                    this.type.toUpperCase(),
                    advrt.trckSlctKey
                );
            }

            advrtEventHandler.clickAdvertisement(advrt);
        },
        advertisementVisibleToUser(advrt) {
            if (
                advrt &&
                ((advrt.advrtProdKey && advrt.shopListKey) || advrt.trckSlctKey)
            ) {
                marketingEventHandler.advertisementDisplay(
                    advrt.advrtProdKey,
                    advrt.shopListKey,
                    this.type.toUpperCase(),
                    advrt.trckSlctKey
                );
            }
        },
        shuffle() {
            this.randomSeed++;
        }
    }
};
</script>
